import axios from 'axios';
const DEPLOYED='myyecomercebackend-production.up.railway.app'
const LOCALHOST='http://localhost:5454'

export const API_BASE_URL = DEPLOYED

const api = axios.create({
  baseURL: API_BASE_URL,
  withCredentials: true, // Add this line
});

const token = localStorage.getItem('jwt');

api.defaults.headers.common['Authorization'] = `Bearer ${token}`;

api.defaults.headers.post['Content-Type'] = 'application/json';

api.interceptors.response.use(
  response => response,
  error => {
    console.error('AxiosError:', error);
    return Promise.reject(error);
  }
);

export default api;
